package games.polyclub.website.frontend.store.components

import games.polyclub.frontend.lib.react.bootstrap.css.utility.bScreenReaderOnly
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.div
import games.polyclub.frontend.lib.react.simplified.tags.span
import js.core.jso
import react.Props
import react.dom.aria.AriaRole
import web.cssom.*

val Loading = SFC<Props> { _ ->
    div("spinner-border text-primary") {
        role = AriaRole.status
        style = jso {
            display = Display.block
            margin = Margin(0.px, Auto.auto)
            width = 10.rem
            height = 10.rem
        }
        span {
            bScreenReaderOnly = true
            +"Loading..."
        }
    }
}
